import { render, staticRenderFns } from "./Known.vue?vue&type=template&id=605fb49e&scoped=true&"
import script from "./Known.vue?vue&type=script&lang=js&"
export * from "./Known.vue?vue&type=script&lang=js&"
import style0 from "./Known.vue?vue&type=style&index=0&id=605fb49e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605fb49e",
  null
  
)

export default component.exports